import React, { useState, useEffect } from 'react';
import {Button} from '@momentum-ui/react';
import style from './copyicon.css'
import '@momentum-ui/web-components';

function CopyIcon(props) {

    const [iconName, setIconName] = useState('icon-copy_12');
 
    useEffect(() => {
      iconName === 'icon-check-circle-active_24' ? setTimeout(() => {
        setIconName('icon-copy_12');
      }, 1000) 
      : false
    })

    let onClick4copyIcon = (values) => {
        navigator.clipboard.writeText(values);
        setIconName('icon-check-circle-active_24');
    }

    const copiedIconProps = {
      color:'#00823B',
      style: {'fontSize':'36px'}
    };


    return (
    <md-theme>
    <md-tooltip
      message = {iconName === 'icon-copy_12'? 'Copy' : 'Copied'}
      placement='top'>

    <Button className={iconName === 'icon-copy_12'? style.copyIcon : style.copyTick}
        style={{width:'19px', height:'19px', 'border-radius':'100px'}} id='imi-call-var-copy'
        circle
        children={

          <md-icon name={iconName} {...(iconName === 'icon-copy_12'? {}:copiedIconProps)}/>
        }
      	onClick={() => {
            iconName === 'icon-copy_12' ?
            onClick4copyIcon(props.value) : false;
		    }
        }
      	ariaLabel='Copy'
		/>

    </md-tooltip>
	</md-theme>
  )
}

export default CopyIcon